import React from 'react';

const Farbeinstellungen = ({ backgroundContent }) => {
  return (
    <div className="sm:col-span-4">
      <label
        htmlFor="backgroundContent"
        className="block text-sm font-medium leading-6 text-gray-900"
      >
        Farbe auswählen
      </label>
      <div className="mt-2">
        <input
          type="color"
          name="backgroundContent"
          id="backgroundContent"
          defaultValue={backgroundContent}
        />
      </div>
    </div>
  );
};

export default Farbeinstellungen;
